import styled from "styled-components";

export const AI_CONCIERGE_FONT_FAMILY =
  '"Arial", "Yu Gothic", "YuGothic", "Yu Gothic Medium", "Hiragino Kaku Gothic ProN", "Meiryo", sans-serif';

export const AssistantWrapperStyle = styled.div<{ backgroundImageSrc: string }>`
  position: relative;
  background-image: ${(props) => `url(${props.backgroundImageSrc})`};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const BackgroundWrapper = styled.div<{
  src: string;
  isVisible: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-image: ${(props) => `url(${props.src})`};
  background-size: cover;
  background-position: center;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  pointer-events: none;
`;

export const FrontImageWrapper = styled.div<{ frontImageSrc: string }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-image: ${(props) => `url(${props.frontImageSrc})`};
  background-size: cover;
  background-position: center;
`;

export const CharacterCommentArea = styled.div<{ src: string }>`
  position: absolute;
  padding-top: 15px;
  padding-right: 30px;
  z-index: 3;
  top: 1200px;
  left: 140px;
  width: 900px;
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 48px !important;
  font-family: ${AI_CONCIERGE_FONT_FAMILY};
  font-weight: 700;
  color: #3e4da3;
  background-image: ${(props) => `url(${props.src})`};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;
